import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import {Helmet} from "react-helmet";
import Main from '../../components/Layout/Main'
import CoverImage from "../../components/CoverImage";
import Section from '../../components/Layout/Section/Section';
import InnerContainer from '../../components/Layout/InnerContainer/InnerContainer';
import StatisticBlocks from '../../components/StatisticBlocks';
import Star from '../../components/Dividers/star';
import InsightBlocks from '../../components/InsightBlocks';

import './insights.scss';

const Insights = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query InsightsQuery {
      markdownRemark(frontmatter: { pageId: { eq: "insights-page" } }) {
        frontmatter {
          components {
            type
            headline
            body {
              line
            }
            blocks {
              headline
              headline2
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
              body
              bullets {
                bullet
              }
            }
            attr
            image {
              childImageSharp {
                fluid(maxWidth: 2048, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
              extension
              publicURL
            }
          }
        }
      }
    }
  `);

  function getComponent(name) {
    const components = markdownRemark.frontmatter.components;
    return components.filter(component => component.type === name)[0];
  }

  const CoverImageContent = getComponent("insightsCoverImage");
  const CoverImage2Content = getComponent("coverImage2");
  const StatisticsContent = getComponent("statisticsBlocks");
  const Statistics2Content = getComponent("statisticsBlocks2");
  const InsightsContent = getComponent("insightBlocks");
  const Insights2Content = getComponent("insightBlocks2");

  return (
    <Main>
      <Helmet>
        <body className="insights-page" />
      </Helmet>
      <CoverImage
        image={CoverImageContent.image}
        headline={CoverImageContent.headline}
        subhead={CoverImageContent.subhead}
        hero="hero"
      />
      <Section customClass={["pull-quote", "color-block", "bg-yellow"]}>
        <Star customClass="star--top"/>
          <p className="pull-quote__body large ">THE VMAs…</p>
        <Star customClass="star--bottom"/>
      </Section>
      <Section>
        <InnerContainer customClass="statistic-blocks">
          <StatisticBlocks blocks={StatisticsContent.blocks}/>
        </InnerContainer>
      </Section>
      <Section customClass={["color-block", "bg-green"]}>
        <InnerContainer customClass="pull-quote">
          <Star customClass="star--top"/>
            <p className="pull-quote__body large ">ALL EYES ON VMAS</p>
            <p className="pull-quote__body">Most ever minutes consumed.</p>
          <Star customClass="star--bottom"/>
        </InnerContainer>
      </Section>
      <Section>
        <InnerContainer customClass="insight-blocks">
            <InsightBlocks blocks={InsightsContent.blocks}/>
        </InnerContainer>
      </Section>
      <Section customClass={["pull-quote", "color-block"]}>
        <Star customClass="star--top"/>
          <p className="pull-quote__body large ">DIGITAL WINS</p>
          <p className="pull-quote__body">Our fans tuned-in and stayed connected.</p>
        <Star customClass="star--bottom"/>
      </Section>
      <Section>
        <InnerContainer customClass="insight-blocks">
          <InsightBlocks blocks={Insights2Content.blocks}/>
        </InnerContainer>
      </Section>
      <CoverImage
        image={CoverImage2Content.image}
        headline={CoverImage2Content.headline}
        variant="wavy"
      />
      <Section customClass={["pull-quote", "color-block", "bg-pink"]}>
        <Star customClass="star--top"/>
          <p className="pull-quote__body large ">RESULTING IN GROWTH AND REACH EVERYWHERE, THE VMAs…</p>
        <Star customClass="star--bottom"/>
      </Section>
      <Section>
        <InnerContainer customClass="statistic-blocks">
          <StatisticBlocks blocks={Statistics2Content.blocks}/>
        </InnerContainer>
      </Section>
    </Main>
  );
}

export default Insights
